"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
const react_1 = __importDefault(require("react"));
const merlin_date_picker_1 = require("@travelnest/merlin.date-picker");
const styled_1 = __importDefault(require("@emotion/styled"));
const theme_1 = __importDefault(require("../../styles/theme"));
// TODO: This should be ported back into Merlin
const StyledDatePickerWrapper = styled_1.default.div `
	.merlin-datepicker__input {
		font-size: ${theme_1.default.typography.c3.fontSize} !important;
		line-height: ${theme_1.default.typography.c3.lineHeight} !important;
		font-weight: ${theme_1.default.typography.c3.fontWeight} !important;

		border-color: ${(props) => `${props.valid ? theme_1.default.colours.neutral.light : theme_1.default.colours.error.primary} !important`};
		color: ${(props) => `${props.valid ? theme_1.default.colours.text.darker : theme_1.default.palette.red.primary} !important`};

		transition: border-color ${theme_1.default.motion.transition.default} !important;

		&:hover {
			border-color: ${(props) => `${props.valid ? theme_1.default.colours.neutral.dark : theme_1.default.colours.error.primary} !important`};
		}
	}
`;
const DatePicker = (props) => {
    return react_1.default.createElement(StyledDatePickerWrapper, { valid: props.valid !== undefined ? props.valid : true },
        react_1.default.createElement(merlin_date_picker_1.DatePicker, Object.assign({}, props)));
};
exports.DatePicker = DatePicker;
//# sourceMappingURL=DatePicker.js.map